import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/sr';
import 'dayjs/locale/ru';
import 'dayjs/locale/en';
import 'dayjs/locale/sq';
import 'dayjs/locale/pl';
import 'dayjs/locale/zh-cn';
import { FALLBACK_LNG, SUPPORTED_LNGS } from './shared/constants';

// Extend dayjs with plugins
dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);

// i18next language codes match dayjs locale names one-to-one except where the
// dayjs locale is region-qualified; dayjs.locale('zh') would silently keep the
// previous locale, so translate the code before handing it over.
const DAYJS_LOCALES = { zh: 'zh-cn' };
const toDayjsLocale = (lng) => DAYJS_LOCALES[lng] ?? lng;

void i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    returnEmptyString: false,
    fallbackLng: FALLBACK_LNG,
    supportedLngs: SUPPORTED_LNGS,
    debug: false,
    ns: [
      'translations',
      'menus',
      'tables',
      'forms',
      'messages',
      'dashboard',
      'timesheetReview',
      'energyTools',
      'timesheetOverview',
      'fleet',
      'assistant',
      'history',
      'officialTravel',
      'clientReports',
      'taxReturns',
      'vatNotices',
    ],
    defaultNS: 'translations',
    keySeparator: '.',
    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18n: 'languageChanged',
      transEmptyNodeValue: '',
      useSuspense: true,
    },
    detection: {
      order: ['cookie', 'htmlTag', 'localStorage', 'path', 'subdomain'],
      caches: ['cookie'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

// Sync dayjs locale with i18next language changes
i18n.on('languageChanged', (lng) => {
  dayjs.locale(toDayjsLocale(lng));
});

// Set initial dayjs locale
dayjs.locale(toDayjsLocale(i18n.language));

export default i18n;
